const { includes } = require('lodash');
var Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.Inventory = (function () {
  var TRUE = 'true';
  var conditionField = '#product-condition';
  var hasInventoryField = '#product-has-inventory';
  var inventoryField = '#product-inventory';

  function toggleInventory() {
    var inventorySection = $('[data-show-for-inventory-conditions]');

    toggleSection(inventorySection, canHaveInventory());
    toggleHasInventory();
  }

  function canHaveInventory() {
    var inventoryConditions = $(conditionField).data('inventory-conditions');
    var selectedCondition = $(conditionField).val();
    var canHaveInventory = false;

    if (inventoryConditions) {
      canHaveInventory = includes(inventoryConditions, selectedCondition);
    }

    return canHaveInventory;
  }

  function toggleInventoryOnChange() {
    $(conditionField).change(toggleInventory);
  }

  function toggleHasInventory() {
    var inventorySection = $('[data-show-for-inventoried]');
    var hasInventory = $(hasInventoryField).val() === TRUE;

    toggleSection(inventorySection, hasInventory && canHaveInventory());
  }

  function toggleHasInventoryOnChange() {
    $(hasInventoryField).change(toggleHasInventory);
  }

  function toggleSection(section, condition) {
    var field = section.find('input, select');

    if (condition) {
      field.prop('disabled', false);
      field.trigger('liszt:updated');
      section.fadeIn();
    } else {
      field.prop('disabled', true);
      field.trigger('liszt:updated');
      section.hide();
    }
  }

  function init() {
    toggleInventoryOnChange();
    toggleInventory();

    toggleHasInventoryOnChange();
  }

  return {
    init: init
  };
})();

$(Reverb.Listing.Inventory.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/inventory.js